import { useQuery } from "@tanstack/react-query"
import { DeviceGet } from "../app/models/Device"
import { digitalManagerApi } from "../services/api"

export function useDevices() {
  const { data: devicesList = [], isLoading: isLoadingDevices } = useQuery({
    queryKey: ["devices"],
    queryFn: () => digitalManagerApi.get<DeviceGet[]>(`/devices`).then((r) => r.data),
  })

  return {
    devicesList,
    isLoadingDevices,
  }
}
